import { render, staticRenderFns } from "./PercentageCircle.vue?vue&type=template&id=48d7b330&"
import script from "./PercentageCircle.vue?vue&type=script&lang=ts&"
export * from "./PercentageCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports